//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Kirbylink from "./kirbylink.vue";

 export default
 {
    name: "footeralt",
    props: {
        content: Object
    },
    components: { Kirbylink }
}

